import React from 'react';
import { Col, Row } from 'react-bootstrap';
import GenericCard from '../GenericCards';
import Avatar, { AvatarSize, AvatarStatus } from '../Avatar';
import IconButton from '../IconButton';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import Button from '../Button';
import { useNavigate } from 'react-router-dom';
import { VERIFY_DEPENDENT_ROUTE } from '../../routes/types';
import { DateFormats, formatDate } from '../../utils/utils';
import Popover from '../Popover';

export type customFamilyMemberCardProps = React.PropsWithoutRef<{
  className?: string;
  name: string,
  image: string,
  covers: string[] | null,
  isVerified: boolean | null,
  ssn: number | null,
  dateOfBirth: number,
  relationship: string,
  isActionRequired: boolean,
}>;

const FamilyMemberCard = (
  {
    className = '',
    name,
    covers,
    image,
    isVerified,
    ssn,
    dateOfBirth,
    relationship,
    isActionRequired,
  }: customFamilyMemberCardProps) => {
  const navigate = useNavigate();

  const actionRequiredPopoverBody = () => (
    <>
      <Row className={'mb-3'}>
        <Col>
          <span className={'fw-normal text-fs-6 lh-xs'}>Action Required</span>
        </Col>
      </Row>
      <Row className={'d-flex flex-column lh-xs'}>
        <Col>
          <span className='fw-light text-fs-6 lh-xs'>Verification Required</span>
        </Col>
        <Col>
          <span className='fw-light text-fs-6 lh-xs'>
            Deadline: {formatDate(new Date(), DateFormats.MONTH_DAY_YEAR)}
          </span>
        </Col>
      </Row>
    </>
  );

  return (
    <GenericCard
      className={`family-member-card ${className}`}
      variant={'white'}
      withShadow={false}
    >
      <Row className={'row-wrapper'}>
        <Col xs={12} lg={4} className={'d-flex align-items-start gap-4'}>
          <Row className={'m-0'}>
            <Col className={'p-0'}>
              <Avatar
                id={name}
                size={AvatarSize.MEDIUM}
                image={image}
                name={name}
                status={AvatarStatus.ENABLED}
              />
            </Col>
            <Col xs={'auto'} className={'personal-info p-0 d-flex flex-column'}>
              <span className={'personal-info-name'}>
                {name}
              </span>
              <span>
                {relationship}
              </span>
              <span>
                {formatDate(new Date(dateOfBirth), DateFormats.US)}
              </span>
            </Col>
          </Row>
        </Col>
        <Col xs={12} lg={4} className={'d-flex align-items-center'}>
          <span className={'text-primary'}>
            {covers ? covers.join(', ') : ''}
          </span>
        </Col>
        <Col xs={12} lg={4}
             className={'d-flex align-items-center justify-content-start  justify-content-lg-end gap-10'}>
          {isActionRequired && (
            <Row className={'is-action-required-btn'}>
              <Col>
                <Popover
                  trigger={['click', 'focus']}
                  placement='top-end'
                  popoverBody={actionRequiredPopoverBody()}
                >
                  <IconButton
                    variant='icon-alert'
                    icon={light('info-circle')}
                    size='sm'
                  />
                </Popover>
              </Col>
            </Row>

          )}
          {!ssn && (
            <Button
              size={'sm'}
              variant={'primary'}
              onMouseDown={() => {
              }}
            >
              Add SSN
            </Button>
          )}
          {isVerified ? (
            <Button
              size={'sm'}
              variant={'success-outline'}
              onMouseDown={() => {
              }}
              leftIcon={light('circle-check')}
            >
              Verified
            </Button>
          ) : (
            <Button
              size={'sm'}
              variant={'primary'}
              onMouseDown={() => {
                navigate(VERIFY_DEPENDENT_ROUTE);
              }}
            >
              Verify Dependent
            </Button>
          )}
        </Col>
      </Row>
    </GenericCard>
  );
};

export default FamilyMemberCard;
